// @flow
export const MODEL = 'Migrate'
export const TREE = 'assetMigrateData'
export const BRANCH = 'assetMigrate'

export const OPERATIONS_TREE = 'assetMigrateModule'
export const OPERATIONS_BRANCH = 'operations'

// Operation state
export const OPERATION_STATE = 'asset'


// Api End Point
export const URL = 'asset/migrate/'

// Model Properties
export const PROP_ID = 'id'
export const PROP_FARM = 'farm'
export const PROP_AVAILABLE_SOURCE_SEASONS = 'availableSourceSeasons'
export const PROP_SOURCE_SEASON = 'sourceSeason'
export const PROP_AVAILABLE_DESTINATION_SEASONS = 'availableDestinationSeasons'
export const PROP_DESTINATION_SEASON = 'destinationSeason'
export const FIELDS_TO_MIGRATE = 'fieldsToMigrate'

